import { render, staticRenderFns } from "./Laporan.vue?vue&type=template&id=61760ff8&scoped=true&"
import script from "./Laporan.vue?vue&type=script&lang=js&"
export * from "./Laporan.vue?vue&type=script&lang=js&"
import style0 from "./Laporan.vue?vue&type=style&index=0&id=61760ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61760ff8",
  null
  
)

export default component.exports